import React, { useEffect, useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Certification_Modal from "../../../../../../../common/common_modal/certification_modal/Certification_Modal";
import Gray_Btn from "../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Refresh_btn from "../../../../../../../common/common_btn/refresh_btn/Refresh_btn";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";

function Legel_Entity_Edit_offcanvas({ show, handleClose }) {
   const [success, setSuccess] = useState(false);

  // ⏱ Auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  return (
    <>
      <Offcanvas
        className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
        show={show}
        placement="end"
        onHide={handleClose}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <div className="back_div" onClick={handleClose}>
              <Common_Back_Btn />
            </div>
            Edit Legal Entity
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="white_container customer_section">
            <div className="row">
              {/* Legal Entity Name */}
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Legal Entity Name</Form.Label>
                  <Form.Control value="NLC INDIA LIMITED" />
                </Form.Group>
              </div>

              {/* Legal Entity Type */}
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Legal Entity Type</Form.Label>
                  <Form.Control value="Companies Act" />
                </Form.Group>
              </div>

              {/* Date of Establishment */}
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Date of Establishment</Form.Label>
                  <Form.Control value="14/11/2025" />
                </Form.Group>
              </div>

              {/* Other Accreditations */}
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Other Accreditations</Form.Label>
                  <Form.Control placeholder="Enter Accreditations" />
                </Form.Group>
              </div>

              {/* Companies Act Certificate */}
              <div className="col-md-7">
                <Form.Group className="form_group file_field">
                  <Form.Label>Companies Act Certificate</Form.Label>

                  <div className="image_holder">
                    <img
                      src="/assets/images/other/dummy-image.png"
                      className="img_preview"
                      alt=""
                    />
                    <FontAwesomeIcon icon={faTrashCan} className="delete_icon" />
                  </div>

                  <div className="span_text_holder">
                    <span>Imperiality PDF.2Kb</span>
                  </div>
                </Form.Group>
              </div>

              {/* Attached File */}
              <div className="col-md-7">
                <Form.Group className="form_group file_field">
                  <Form.Label>
                    Attached File <sup>(i.e pancard / adhar card)</sup>
                  </Form.Label>

                  <div className="image_holder">
                    <img
                      src="/assets/images/other/dummy-image.png"
                      className="img_preview"
                      alt=""
                    />
                    <FontAwesomeIcon icon={faTrashCan} className="delete_icon" />
                  </div>
                   <div className="span_text_holder">
                    <span>Front Side</span>
                  </div>
                </Form.Group>
              </div>

              {/* Back Side */}
              <div className="col-md-7">
                <Form.Group className="form_group file_field">

                  <div className="image_holder">
                    <img
                      src="/assets/images/other/dummy-image.png"
                      className="img_preview"
                      alt=""
                    />
                    <FontAwesomeIcon icon={faTrashCan} className="delete_icon" />
                  </div>

                    <div className="span_text_holder">
                    <span>Back Side</span>
                  </div>
                </Form.Group>
              </div>

            
            </div>
          </div>
            <div className="offcanvas_footer_holder">
          {success ? (
            <Success_Toster successText="Instrument Added Successfully!" />
          ) : (
            <>
              <div className="btns_holder">
                <Gray_Btn btnText="Cancel" />
                <Black_Submit_Btn
                  btnText="Submit"
                  onClick={() => setSuccess(true)}
                />
              </div>
              <Refresh_btn />
            </>
          )}
        </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Legel_Entity_Edit_offcanvas;
